<app-context-menu-item
  title="Insert section before"
  [close]="true"
  (execute)="addTop()"
/>

<app-context-menu-item
  title="Insert section after"
  [close]="true"
  (execute)="addBottom()"
/>

<app-context-menu-item
  title="Move up"
  [close]="true"
  (execute)="moveUp()"
  [disabled]="!canMoveUp"
/>

<app-context-menu-item
  title="Move down"
  [close]="true"
  (execute)="moveDown()"
  [disabled]="!canMoveDown"
/>

<app-context-menu-divider />

<app-context-menu-item
  title="Delete"
  [close]="true"
  (execute)="delete()"
/>
